export default __webpack_public_path__ + "ade87a8c195f5857dcf3e3c7f78f6da6.woff";